import { observer } from 'mobx-react-lite'
import { GestureResponderEvent, Platform, StyleSheet } from 'react-native'

import { DS } from '../../../../../design-system'
import { BottomSheetView } from '@gorhom/bottom-sheet'

export type ConfirmOption = {
  text: string
  onPress: (event?: GestureResponderEvent) => void
}

export interface ConfirmProps {
  text: string
  subtext?: string
  confirm: ConfirmOption
  cancel: ConfirmOption
}

export const Confirm = observer(({ text, subtext, confirm, cancel }: ConfirmProps) => {
  return (
    <BottomSheetView style={Platform.OS !== 'web' ? { flex: 1 } : {}}>
      <DS.Frame gap="24" alignItems="center" bg="Brand/Cream" flex={1} style={styles.container}>
        <DS.Frame gap="4">
          <DS.Text textAlign="center" variant="Heading 2/Medium">
            {text}
          </DS.Text>
          {subtext ? (
            <DS.Text textAlign="center" variant="Body Small/Regular">
              {subtext}
            </DS.Text>
          ) : null}
        </DS.Frame>
        <DS.Frame gap="8">
          <DS.Button onPress={confirm.onPress} style={styles.btn} variant="Large/Primary" type="On Light">
            {confirm.text}
          </DS.Button>
          <DS.Button onPress={cancel.onPress} style={styles.btn} variant="Large/Secondary" type="On Dark">
            {cancel.text}
          </DS.Button>
        </DS.Frame>
      </DS.Frame>
    </BottomSheetView>
  )
})

const styles = StyleSheet.create({
  container: {
    padding: DS.spacing[24],
    paddingTop: DS.spacing[8]
  },
  btn: {
    width: '100%'
  }
})
